import { localStoragePrefix } from "@/config";
import { TOKEN } from "../constants";

export default {
  Language: [],
  errorGetLanguage: null,
  loadingGetLanguage: false,
};
